import indexablePages from './indexablePages.json';

export type SeoPageEntry = {
  path: string;
  title: string;
  description: string;
};

const indexableList = indexablePages as SeoPageEntry[];

function mapKeyForEntry(path: string): string {
  return normalizePath(path);
}

const INDEXABLE_MAP = new Map<string, SeoPageEntry>(
  indexableList.map((entry) => [mapKeyForEntry(entry.path), entry])
);

function normalizePath(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  const trimmed = pathname.replace(/\/$/, '');
  return trimmed || '/';
}

export function getIndexablePaths(): string[] {
  return indexableList.map((p) => p.path);
}

export function isIndexablePath(pathname: string): boolean {
  return INDEXABLE_MAP.has(normalizePath(pathname));
}

export function getSeoForPath(pathname: string): SeoPageEntry & { noIndex: boolean } {
  const key = normalizePath(pathname);
  const entry = INDEXABLE_MAP.get(key);
  if (entry) {
    return { ...entry, noIndex: false };
  }
  return {
    path: key,
    title: 'Horse Racing Oracle',
    description: 'UK-focused automated Betfair betting on horse racing with strict parameters and risk management.',
    noIndex: true,
  };
}

export function shouldNoIndexPath(pathname: string): boolean {
  const key = normalizePath(pathname);
  if (key.startsWith('/dashboard')) return true;
  return !isIndexablePath(key);
}
